module.exports = __webpack_public_path__ + "media/images/df-magazine-winter-2023-f87b972f.jpeg";